import {DESTROY_ACCOUNT, SET_ACCOUNT} from "@/core/store/modules/account/constants";
import pusher from "@/core/services/pusher.service";

export default {
    [SET_ACCOUNT](state, account) {
        pusher.connect()
        state.account = account.profile
        state.middlewares = account.middlewares

    },
    [DESTROY_ACCOUNT](state) {
        state.account = {}
        state.middlewares = {}
     }
}